import { render, staticRenderFns } from "./OrdersOnline.vue?vue&type=template&id=071453b8&scoped=true&"
import script from "./OrdersOnline.vue?vue&type=script&lang=js&"
export * from "./OrdersOnline.vue?vue&type=script&lang=js&"
import style0 from "./OrdersOnline.vue?vue&type=style&index=0&id=071453b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071453b8",
  null
  
)

export default component.exports